import React, { Component } from "react";
import ReactDOM from "react-dom";
import { SSL_OP_NETSCAPE_REUSE_CIPHER_CHANGE_BUG } from "constants";
import Base from "./Base";
import * as actionsCart from "../actions/index";

export default class ItemsBase extends Base {
	constructor(props) {
		super(props);
		this.state = {};

		this.hasPrice = false;
		this.hasMonthlyPrice = false;
		this.hasPointsPrice = false;
	}

	renderAfterLoad() {
		if (
			this.props.cartReducer.cart.offers == null ||
			this.props.cartReducer.cart.offers <= 0
		) {
			return this.renderItemsEmpty();
		}
		const availablePrices = this.getAvailablePrices(
			this.props.cartReducer.cart.offers
		);
		this.hasPrice = availablePrices.hasPrice;
		this.hasMonthlyPrice = availablePrices.hasMonthlyPrice;
		this.hasPointsPrice = availablePrices.hasPointsPrice;

		return this.renderItems(this.props.cartReducer.cart.offers);
	}

	renderItemsEmpty() {
		return null;
	}

	renderItems(items) {
		return null;
	}

	getAvailablePrices(items) {
		const res = {
			hasPrice: false,
			hasMonthlyPrice: false,
			hasPointsPrice: false
		};

		if (items != null) {
			for (let i = 0; i < items.length; i++) {
				const availablePrice = this.getAvailablePrice(items[i]);
				res.hasPrice = !res.hasPrice ? availablePrice.hasPrice : res.hasPrice;
				res.hasMonthlyPrice = !res.hasMonthlyPrice
					? availablePrice.hasMonthlyPrice
					: res.hasMonthlyPrice;
				res.hasPointsPrice = res.hasPointsPrice || availablePrice.hasPointsPrice;
			}
		}

		return res;
	}

	getAvailablePrice(item) {
		const res = {
			hasPrice: false,
			hasMonthlyPrice: false,
			hasMonthlyPrice: false
		};

		if (item.cartItems != null) {
			for (let j = 0; j < item.cartItems.length; j++) {
				res.hasPrice = !res.hasPrice
					? item.cartItems[j].price != null && item.cartItems[j].price != 0
					: res.hasPrice;
				res.hasMonthlyPrice = !res.hasMonthlyPrice
					? item.cartItems[j].monthlyPrice != null &&
					  item.cartItems[j].monthlyPrice != 0
					: res.hasMonthlyPrice;
				res.hasPointsPrice =
					res.hasPointsPrice ||
					(item.cartItems[j].pointsPrice != null &&
						item.cartItems[j].pointsPrice != 0);
			}
		}

		if (item.cartOffers != null) {
			for (let i = 0; i < item.cartOffers.length; i++) {
				const availablePrice = this.getAvailablePrice(item.cartOffers[i]);
				res.hasPrice = !res.hasPrice ? availablePrice.hasPrice : res.hasPrice;
				res.hasMonthlyPrice = !res.hasMonthlyPrice
					? availablePrice.hasMonthlyPrice
					: res.hasMonthlyPrice;
				res.hasPointsPrice = res.hasPointsPrice || item.hasPointsPrice;
			}
		}

		return res;
	}

	goToCheckout() {
		this.props.dispatch(actionsCart.goToCheckout());
	}
}
